/**
 * Central shortcut definitions.
 * - fkey: traditional Tally F-key (may be intercepted by browser — F1/F5/F7 especially)
 * - alt:  Alt+digit fallback that always works in browsers
 * - label/path: navigation target
 */
export const SHORTCUTS = [
  { fkey: "F1", alt: "1", label: "Dashboard", path: "/" },
  { fkey: "F3", alt: "3", label: "Companies", path: "/companies" },
  { fkey: "F4", alt: "4", label: "Contra", path: "/vouchers/new/Contra" },
  { fkey: "F5", alt: "5", label: "Payment", path: "/vouchers/new/Payment" },
  { fkey: "F6", alt: "6", label: "Receipt", path: "/vouchers/new/Receipt" },
  { fkey: "F7", alt: "7", label: "Journal", path: "/vouchers/new/Journal" },
  { fkey: "F8", alt: "8", label: "Sales", path: "/vouchers/new/Sales" },
  { fkey: "F9", alt: "9", label: "Purchase", path: "/vouchers/new/Purchase" },
];

export function isTypingInFormField(target) {
  if (!target) return false;
  const tag = (target.tagName || "").toLowerCase();
  if (target.isContentEditable) return true;
  return ["input", "textarea", "select"].includes(tag);
}
